/**
 * Header event models (order-form / consumer side).
 * Duplicated from app header events — no import from header module.
 * Source: apps/kala-mobile/src/app/components/header/events/header-events.model.ts
 */

import { IconNames } from '@icon/assets';

export interface HeaderItemToHeader {
	iconName: IconNames;
	iconClass?: string;
	eventId: string;
	ariaLabel?: string;
	reloading?: boolean;
}

export interface HeaderSymbolToHeader {
	name: string;
	groupId?: number;
}

export interface HeaderConfigurationToHeader {
	showLogo?: boolean;
	title?: string;
	symbol?: HeaderSymbolToHeader | null;
	headerRightSectionItems?: HeaderItemToHeader[];
	headerLeftSectionItems?: HeaderItemToHeader[];
}

export interface HeaderActionEventFromHeader {
	eventId: string;
}

export const ORDER_FORM_HEADER_EVENTS = {
	HEADER_CONFIGURATION: 'header.configuration',
	HEADER_ACTION: 'header.action'
} as const;
